import { Injectable, inject } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { billingScope, productConfig, productsToSell } from '../consts';
import { getBillingScopes } from '../lib/get-allowed-feedback-options';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private state = inject(StateService);

  public canDisplayElement(scope: billingScope, gallery?: GalleryDto): boolean {
    const scopes = this.getPermissions(gallery);
    if (!scopes) return false;
    return scopes.includes(scope);
  }

  private getPermissions(gallery: GalleryDto) {
    if (!gallery) {
      if (!this.state.plan) return;
      return this.state.plan.scopes;
    }
    return getBillingScopes(gallery, this.state.plan);
  }

  public getMinPlanForScope(scope: billingScope): string {
    const plans = Object.keys(productConfig)
      .filter(planName => productConfig[planName].scopes.includes(scope))
      .map(planName => planName.split('Picflow ')[1].toLowerCase());

    return productsToSell.find(productName => plans.includes(productName));
  }

  public shouldRedirectToPricingPage(tenantId: string): boolean {
    if (!tenantId || tenantId === this.state.activeTenant?.id) {
      return ['admin', 'owner'].includes(this.state.activeTenantRole);
    }
    return false;
  }

  public hasRolePermission(permission: string): boolean {
    if (!this.state.activeTenantPermissions) return false;
    return this.state.activeTenantPermissions.includes(permission);
  }
}
